import { isBuildingRegex, isHomepageRegex } from 'hybridspace-telemetry';

export function isPlacesHomePage(pathname: string): boolean {
    const homepageRegex = new RegExp(isHomepageRegex, 'i' /* Flag for case insensitive */);
    const buildingRegex = new RegExp(isBuildingRegex, 'i' /* Flag for case insensitive */);
    return (pathname.match(homepageRegex) || pathname.match(buildingRegex) || []).length > 0;
}
